import { render } from "./doctemplate.vue?vue&type=template&id=2b897eb2&scoped=true"
import script from "./doctemplate.js?vue&type=script&lang=js"
export * from "./doctemplate.js?vue&type=script&lang=js"

import "./doctemplate.vue?vue&type=style&index=0&id=2b897eb2&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b897eb2"]])

export default __exports__